export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.26-1004.49",
  commitId: "a4e188bf979b574c1d023097c0bb30adc339d1a8",
  commitTime: "2026-10-26T10:04:49.000Z",
});
